import React from "react";
import SimpleTooltip from "./SimpleTooltip";
import { IoMdRefresh } from "react-icons/io";

class ForceRefreshButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { handleRefresh, isLoading } = this.props;

    return (
      <>
        <SimpleTooltip tooltipText="Force Refresh">
          <button
            type="button"
            className="hover:shadow p-1 text-gray-600 hover:text-blue-600"
            onClick={() => {
              if (isLoading) return;
              handleRefresh();
            }}
            disabled={isLoading}
          >
            {isLoading ? "loading..." : <IoMdRefresh></IoMdRefresh>}
          </button>
        </SimpleTooltip>
      </>
    );
  }
}

export default ForceRefreshButton;
